import { Box } from "@mui/material";

const MergeTagChip = ({ mergeTag }: { mergeTag: string }) => {
  return (
    <Box
      component="span"
      sx={{
        color: "purple.dark",
        borderRadius: 4,
        boxDecorationBreak: "clone",
        py: 0.5,
        px: 1,
        border: "1px solid",
        borderColor: "purple.light",
      }}
    >
      {mergeTag}
    </Box>
  );
};

export default MergeTagChip;
